import {
  formatReplacementDemandDate,
  formatReplacementDemandPercent,
  formatReplacementDemandUnits,
  isReplacementDemandShiftWindowActive,
  rowHasReplacementDemandException,
} from '../../../lib/replacementDemandShiftHelpers';

function activeTone(active) {
  return active
    ? 'border-transparent bg-emerald-50 text-emerald-700'
    : 'border-transparent bg-slate-100 text-slate-700';
}

export function ReplacementDemandShiftMainTable({ rows }) {
  return (
    <div className="overflow-hidden rounded-lg border border-gray-200 bg-white">
      <div className="max-h-[calc(100vh-18rem)] overflow-auto">
        <table className="min-w-full text-left text-sm">
          <thead className="sticky top-0 z-10 bg-slate-50 text-xs uppercase tracking-[0.12em] text-gray-500">
            <tr>
              <th className="px-4 py-3 font-medium">Original SKU</th>
              <th className="px-4 py-3 font-medium">Original product</th>
              <th className="px-4 py-3 font-medium">Replacement SKU</th>
              <th className="px-4 py-3 font-medium">Replacement product</th>
              <th className="px-4 py-3 font-medium">Window</th>
              <th className="px-4 py-3 text-right font-medium">Shift %</th>
              <th className="px-4 py-3 text-right font-medium">Original units</th>
              <th className="px-4 py-3 text-right font-medium">Shifted units</th>
              <th className="px-4 py-3 text-right font-medium">Incoming units</th>
              <th className="px-4 py-3 font-medium">Status</th>
            </tr>
          </thead>
          <tbody>
            {rows.length > 0 ? (
              rows.map(row => {
                const active = isReplacementDemandShiftWindowActive(
                  row.shiftStartDate,
                  row.shiftEndDate
                );
                const hasException = rowHasReplacementDemandException(row);
                return (
                  <tr key={row.id} className="border-b border-gray-100 hover:bg-gray-50">
                    <td className="px-4 py-3 align-top font-medium text-gray-900">{row.originalSku}</td>
                    <td className="px-4 py-3 align-top text-gray-600">{row.originalProductName}</td>
                    <td className="px-4 py-3 align-top font-medium text-gray-900">{row.replacementSku}</td>
                    <td className="px-4 py-3 align-top text-gray-600">{row.replacementProductName}</td>
                    <td className="px-4 py-3 align-top text-gray-600">
                      {formatReplacementDemandDate(row.shiftStartDate)} →{' '}
                      {formatReplacementDemandDate(row.shiftEndDate)}
                    </td>
                    <td className="px-4 py-3 text-right align-top text-gray-900">
                      {formatReplacementDemandPercent(row.shiftPercent)}
                    </td>
                    <td className="px-4 py-3 text-right align-top text-gray-900">
                      {formatReplacementDemandUnits(row.originalForecastUnits)}
                    </td>
                    <td className="px-4 py-3 text-right align-top font-medium text-gray-900">
                      {formatReplacementDemandUnits(row.shiftedUnits)}
                    </td>
                    <td className="px-4 py-3 text-right align-top text-gray-900">
                      {formatReplacementDemandUnits(row.replacementIncomingUnits)}
                    </td>
                    <td className="px-4 py-3 align-top">
                      <div className="flex flex-wrap gap-1.5">
                        <span
                          className={`inline-flex rounded-md border px-2 py-1 text-[11px] font-medium ${activeTone(active)}`}
                        >
                          {active ? 'Active' : 'Scheduled'}
                        </span>
                        {hasException ? (
                          <span className="inline-flex rounded-md border border-transparent bg-amber-50 px-2 py-1 text-[11px] font-medium text-amber-700">
                            Needs review
                          </span>
                        ) : null}
                      </div>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td className="px-4 py-10 text-center text-sm text-gray-500" colSpan={10}>
                  No replacement demand rows match the current filters.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
